// extracted by mini-css-extract-plugin
export default {"message":"Profiles_message__Wc48G","loader":"Profiles_loader__GV7bf","tabs":"Profiles_tabs__j-7i8"};